import { saveAs } from 'file-saver';
import { formattedDateTime, mask } from '../../../../utils';

const generateHtml = data => {
  const {
    typeName,
    statusName,
    protocol,
    name,
    // individualRegistration,
    createdAt,
    description,
    contacts: {
      email,
      telephone,
    },
    location: {
      address,
      number,
      complement,
      districtName,
      cityName,
      stateName,
      zipcode
    },
  } = data;


  return `<!DOCTYPE html>
    <html>
      <head>
        <meta charset='UTF-8'>
        <meta content='pt_BR' http-equiv='Content-Language' />

        <title>${protocol}</title>

        <style>
          * { margin: 0; padding: 0; }

          body { margin: 0; padding: 0; font-size: 13px; color: #333333; font-family: sans-serif; }

          h1 { font-size: 18px; font-weight: normal; }

          table { border-collapse: collapse; width:100%; }
          table tr th { text-align: left; text-transform: uppercase; }

          table tr td,
          table tr th { border-bottom: 1px solid #cccccc; border-top: 0px solid #cccccc; padding: 10px 0px; }

          .content { padding: 16px; }
          .result-content { margin: 10px 0 10px 0; }
          </style>
      </head>

      <body>
        <div class='content'>
          <h1>${protocol}</h1>

          <div class='result-content'>
            <table>
              <tr>
                <th colspan='4'>Dados gerais</th>
              </tr>

              <tr>
                <th width='15%'>Protocolo</th>
                <td width='40%'>${protocol}</td>

                <th width='15%'>Cadastrado</th>
                <td width='40%'>${formattedDateTime(createdAt) ?? ''}</td>
              </tr>

              <tr>
                <th width='15%'>Tipo</th>
                <td width='40%'>${typeName || ''}</td>

                <th width='15%'>Status</th>
                <td width='30%'>${statusName || ''}</td>
              </tr>
            </table>
          </div>

          <div class='result-content'>
            <table>
              <tr>
                <th colspan='4'>Dados do solicitante</th>
              </tr>

              <tr>
                <th width='15%'>Nome</th>
                <td width='40%'>${name}</td>

                <th width='15%'>E-mail</th>
                <td width='30%'>${email || ''}</td>
              </tr>

              <tr>
                <th width='15%'>Telefone</th>
                <td colspan='3'>${telephone ? mask(telephone, '(##) #####-####') : ''}</td>
              </tr>
            </table>
          </div>

          <div class='result-content'>
            <table>
              <tr>
                <th colspan='4'>Dados da localidade do solicitante</th>
              </tr>

              <tr>
                <th width='15%'>Endereço</th>
                <td width='40%'>${address || ''}</td>

                <th width='15%'>Número</th>
                <td width='30%'>${number || ''}</td>
              </tr>

              <tr>
                <th width='15%'>Complemento</th>
                <td colspan='3'>${complement || ''}</td>
              </tr>

              <tr>
                <th width='15%'>Bairro</th>
                <td width='40%'>${districtName || ''}</td>

                <th width='15%'>Cidade</th>
                <td width='30%'>${cityName || ''}</td>
              </tr>

              <tr>
                <th width='15%'>Estado</th>
                <td width='40%'>${stateName || ''}</td>

                <th width='15%'>CEP</th>
                <td width='30%'>${zipcode ? mask(zipcode, '#####-###') : ''}</td>
              </tr>
            </table>
          </div>

          <div class='result-content'>
            <table>
              <tr>
                <th colspan='4'>Detalhes do pedido</th>
              </tr>

              <tr>
                <td colspan='4'>${description || ''}</td>
              </tr>
            </table>
          </div>

        </div>
      </body>
    </html>`;
}

export const printOut = (args = {}) => {
  const { data, fileName } = args;
  const actionResultHtml = generateHtml(data);
  const blob = new Blob([actionResultHtml], { type: 'text/html;charset=utf-8' });

  saveAs(blob, fileName);
}
